/* eslint-disable @next/next/no-img-element */
import React from 'react';
import { Button, Modal } from '@material-ui/core';
import styles from './recording-success.module.css';

interface IRecordingUploadSuccessModal {
  open: boolean;
  handleClose: () => void;
  primaryActionText: string;
  primaryClickHandler: () => void;
}

const RecordingUploadSuccessModal: React.FC<IRecordingUploadSuccessModal> =
  props => {
    const {
      open,
      handleClose,
      primaryActionText = 'Okay',

      primaryClickHandler = () => {},
    } = props;

    return (
      <Modal
        className={styles['modal']}
        open={open}
        onClose={(event, reason) =>
          reason !== 'backdropClick' ? handleClose() : f => f
        }
      >
        <div className={styles['inner-container']}>
          <div className={styles['dialog-content']}>
            <div className={styles['hero-image']}>
              <img
                src="/icons/big-fat-tick.svg"
                alt="success"
                className={styles['img']}
              />
            </div>
            <div className='text-center font-bold text-xl'>Recording uploaded successfully!</div>
            <div className={styles['description']}>
              Please refresh the page to see the results on this page in a few
              minutes.
            </div>

            <div className={styles['actions']}>
              <Button
                className={styles['primary-button']}
                variant="contained"
                color="primary"
                onClick={() => primaryClickHandler()}
                disableElevation
                disableRipple
              >
                <h1 className="text-white">{primaryActionText}</h1>
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  };

export default RecordingUploadSuccessModal;
